import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import { setGeneratedOpenAIRequests } from "../../../actions/projectActions";
import {
  getGeneratedBenefits,
  getGeneratedChallenges,
  getGeneratedImage,
  getGeneratedNamesForIdea,
} from "../../../api/ai";
import {
  createIdea,
  createIssuesWithMessages,
  deleteIdea,
  getMessagesByIssuesIds,
  updateIdea,
} from "../../../api/subtractions";
import { archiveIdeas } from "../../../api/trash";
import { uploadImage } from "../../../api/uploads";
import ErrorMessageModal from "../../../components/dialogs/ErrorMessageModal";
import { areObjectsEqual } from "../../../helpers/areObjectsEqual";
import { getTranslation } from "../../../helpers/getLanguage";
import { getUpdatedIdea } from "../../../helpers/getUpdatedIdea";
import { useConfirmationDeleteModal } from "../../../hooks/ideas/useConfirmationDeleteModal";
import { useUndoResetIdea } from "../../../hooks/useUndoResetIdea";
import WarningNotTokensModal from "../../ComponentsDashboard/WarningNotTokensModal";
import BuyMoreAICreditsModal from "../BuyMoreAICreditsModal";
import CheckoutModal from "../CheckoutModal";
import { IdeaModalFooter } from "../commonComponents/IdeaModalFooter";
import { IdeaNavigationFooter } from "../commonComponents/IdeaNavigationFooter";
import ConfirmationModal from "../ConfirmationModal";
import Dialog from "../Dialog";
import TrashModal from "../TrashModal";
import "./styles.css";
import SubtractionModalHeader from "./SubtractionModalHeader";
import SubtractionModalTabs from "./SubtractionModalTabs";

const IDEAS_IDENTIFICATION = {
  EMPTY_IDEA: 0,
  IN_PROGRESS_IDEA: 1,
  NOT_FEASIBLE_IDEA: 2,
  COMPLETED_IDEA: 3,
};

const initialState = {
  existingSubtraction: null,
  isIdeaNew: null,
  isIdeaFeasible: null,
  score: null,
  feasibleScore: null,
  potentialBenefitsOfSubtraction: [{ name: "", description: "", target: [], userInfo: "" }],
  issues: [{ comment: "", description: "", createdByUser: "" }],
  issuesMessages: [],
  ideaName: "",
  removeBenefit: "",
  comment: "",
  image: { name: "", originalName: "", id: "" },
  imagesLibrary: [],
};

const initialPaymentInfo = {
  intervalCount: 1,
  quantity: 1,
  key: "",
  interval: null,
  openAIRequests: null,
  total: null,
  promoCode: "",
  promoCodeOpenAI: "",
};

const initialUpload = {
  progress: 100,
  cancel: null,
  name: "",
  date: "",
  size: 0,
  uploaded: false,
  uploadName: "",
};

const isDefaultCategory = (value) => ["Consumer", "Company", "Other"].includes(value);

const SubtractionEditModal = ({
  closeDialog,
  edit,
  remoteComponent,
  productId,
  project,
  subtractionsMatrix,
  teamId,
  categories = [],
  productType,
  productName,
  language,
  history,
  setGeneratedOpenAIRequests,
  ...props
}) => {
  const [subtraction, setSubtraction] = useState(_.cloneDeep(initialState));
  const [currentTab, setCurrentTab] = useState(0);
  const [isNew, setIsNew] = useState(!edit);
  const [subtractionId, setSubtractionId] = useState(subtractionsMatrix.id);
  const [savedSubtraction, setSavedSubtraction] = useState(_.cloneDeep(initialState));
  const [isPending, setIsPending] = useState({ create: false, update: false });
  const [uploadInfo, setUploadInfo] = useState({ ...initialUpload });
  const [isClosing, setIsClosing] = useState(false);
  const [customCategories, setCustomCategories] = useState([...categories]);
  const [isLoadingImage, setIsLoadingImage] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isCompletedIdea, setIsCompletedIdea] = useState(false);
  const [messages, setMessages] = useState([]);
  const [openGenerateModal, setOpenGenerateModal] = useState(false);
  const [suggestedOptions, setSuggestedOptions] = useState([]);
  const [suggestedLoading, setSuggestedLoading] = useState(false);
  const [error, setError] = useState({
    openErrorModal: false,
    message: "",
    headerError: "",
  });
  const [selectedGenerateOptions, setSelectedGenerateOptions] = useState(new Set());
  const [isOpenGenerateImageModal, setIsOpenGenerateImageModal] = useState(false);
  const [generatedImage, setGeneratedImage] = useState("");
  const [potentialGeneratedImageFile, setPotentialGeneratedImageFile] = useState(null);
  const [potentialGeneratedImageUrl, setPotentialGeneratedImageUrl] = useState("");
  const [newGeneratedImage, setNewGeneratedImage] = useState({
    isNew: false,
    urlImage: "",
  });
  const [isOpenWarningModal, setIsOpenWarningModal] = useState(false);
  const [isOpenBuyCreditsgModal, setIsOpenBuyCreditsgModal] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(initialPaymentInfo);
  const [isEnoghTokensForImage, setIsEnoghTokensForImage] = useState(true);
  const {
    isConfirmationModalOpen,
    handleCloseConfirmationModalOpen,
    handleOpenConfirmationModalOpen,
    isConfirmationDeleteModalOpen,
    handleCloseConfirmationDeleteModalOpen,
    handleOpenConfirmationDeleteModalOpen,
  } = useConfirmationDeleteModal();
  const isDisabledSave = areObjectsEqual(subtraction, initialState);

  const { name: projectName } = project.product;

  const disabledNextButton = currentTab === 1 && (subtraction.score === null || subtraction.score === undefined);

  useEffect(() => {
    (async () => {
      let componentExists = true;
      const issuesParams = subtractionsMatrix.issues ? subtractionsMatrix.issues.map((issue) => issue.id) : [];
      const params = { issues: issuesParams };

      const onSuccess = (response) => {
        if (componentExists) setMessages((prev) => [...prev, ...response]);
      };

      const onError = (error) => {
        console.error(error);
        handleClose(true, { ...isPending, update: false });
      };

      await getMessagesByIssuesIds(params, onSuccess, onError);

      return () => (componentExists = false);
    })();
  }, []);

  useEffect(() => {
    if (edit) updateValues();
  }, [subtractionsMatrix, edit, messages]);

  useEffect(() => {
    if (!isClosing) {
      const isUpToDate = savedSubtraction.image.name === subtraction.image.name;
      if (!isUpToDate) {
        handleSave();
      }
    }
  }, [subtraction.image, isClosing, savedSubtraction]);

  useEffect(() => {
    if (subtraction && subtraction.score && subtraction.feasibleScore) {
      setIsCompletedIdea(true);
    } else {
      setIsCompletedIdea(false);
    }
  }, [subtraction.score, subtraction.feasibleScore]);

  const getStatus = () => {
    const currentSubtraction = getSubtraction();
    const {
      existingSubtraction,
      isIdeaNew,
      isIdeaFeasible,
      score,
      feasibleScore,
      comment,
      issues,
      potentialBenefitsOfSubtraction,
      createsBenefits,
      ideaName,
      image,
    } = currentSubtraction;

    if (
      isIdeaNew === false ||
      existingSubtraction === true ||
      isIdeaFeasible === false ||
      feasibleScore === 0 ||
      score === 0
    ) {
      return IDEAS_IDENTIFICATION.NOT_FEASIBLE_IDEA;
    }

    if (isIdeaFeasible && score > 0) {
      return IDEAS_IDENTIFICATION.COMPLETED_IDEA;
    }

    if (
      !createsBenefits &&
      !isIdeaFeasible &&
      score === null &&
      feasibleScore === null &&
      (issues.length === 1 || issues.length === 0) &&
      !issues[0]?.comment.trim() &&
      potentialBenefitsOfSubtraction.length === 1 &&
      !potentialBenefitsOfSubtraction[0].name.trim() &&
      !comment.trim() &&
      !ideaName.trim() &&
      !image.id
    ) {
      return IDEAS_IDENTIFICATION.EMPTY_IDEA;
    }

    return IDEAS_IDENTIFICATION.IN_PROGRESS_IDEA;
  };

  const getSubtractionDetails = () => {
    const currentSubtraction = getSubtraction();

    return {
      subtractionName: currentSubtraction.ideaName,
      potentialBenefitsOfSubtraction: currentSubtraction.potentialBenefitsOfSubtraction.filter((el) => el.name),
      typeSubtraction: currentSubtraction.isIdeaFeasible,
      issues: currentSubtraction.issues.filter((issue) => issue),
      comments: currentSubtraction.comment,
      removeBenefit: currentSubtraction.removeBenefit,
      rating: currentSubtraction.score,
      feasibleRating: currentSubtraction.feasibleScore,
      image: currentSubtraction.image,
      imagesLibrary: currentSubtraction.imagesLibrary,
      status: getStatus(),
      existingSubtraction: currentSubtraction.existingSubtraction,
    };
  };

  const getIssuesWithMessages = () => {
    const currentSubtraction = getSubtraction();
    const deletedIssues = currentSubtraction.deletedIssues ?? [];

    const getMessagesByIssueIdWithDeletedMessages = (issueId, issueIndex) => {
      const filteredMessages = currentSubtraction.issuesMessages.filter((message) =>
        message.issueId ? message.issueId === issueId : message.issueIndex === issueIndex,
      );
      const deletedMessages = currentSubtraction.deletedIssuesMessages ?? [];

      return [...filteredMessages, ...deletedMessages];
    };

    return [
      ...currentSubtraction.issues.map((issue, index) => ({
        ...issue,
        messages: getMessagesByIssueIdWithDeletedMessages(issue.id, index),
      })),
      ...deletedIssues,
    ];
  };

  const handleClose = (shouldClose, pendingState) => {
    setIsPending(pendingState);
    if (shouldClose) {
      resetSubtractionsMatrix();
      handleCloseDialog();
    }
  };

  const createSubtraction = (shouldClose = false) => {
    if (compareSubtractions(initialState, getSubtraction())) {
      handleClose(shouldClose, { ...isPending, create: false });
      return;
    }

    if (isPending.create) {
      return;
    }

    shouldClose && setIsClosing(true);

    const params = {
      customCategories,
      id: subtractionId,
      idRemoteComponent: remoteComponent.id,
      productId: productId,
      teamId: teamId || "",
      ...getSubtractionDetails(),
    };

    params.imagesLibrary = params.imagesLibrary.map((image) => {
      const imageCopy = { ...image };
      delete imageCopy.imageSource;
      return imageCopy;
    });

    delete params.image.imageSource;

    setIsPending({ ...isPending, create: true });

    const onSuccess = (response) => {
      const issues = getIssuesWithMessages() || [];

      const issuesParams = {
        ideaId: response.id || "",
        issues,
      };

      const onSuccessUpdateIssues = () => {};

      const onErrorUpdateIssues = (error) => {
        console.error(error);
      };

      if (shouldClose) {
        createIssuesWithMessages(issuesParams, onSuccessUpdateIssues, onErrorUpdateIssues);
      }

      setIsNew(false);
      setSubtractionId(response.id);
      handleClose(shouldClose, { ...isPending, create: false });
    };

    const onError = (error) => {
      console.error(error);
      handleClose(shouldClose, { ...isPending, create: false });
    };

    createIdea(params, onSuccess, onError);
  };

  const getSubtraction = () => {
    return { ...subtraction, image: { ...subtraction.image } };
  };

  const { checkedTab, updateHistory, undoResetIdea } = useUndoResetIdea(
    getSubtraction,
    setSubtraction,
    currentTab,
    "subtraction",
  );

  const resetSubtractionsMatrix = () => {
    const currentSubtraction = getSubtraction();
    updateHistory(currentSubtraction);

    const issuesToDelete = currentSubtraction.issues.map((issue) => ({ id: issue.id })) || [];
    const params = {
      issues: issuesToDelete,
      ideaId: subtractionId || "",
    };
    const onSuccess = () => {};
    const onError = (error) => {
      console.error(error);
    };

    params.ideaId && createIssuesWithMessages(params, onSuccess, onError);

    currentSubtraction.potentialBenefitsOfSubtraction.forEach((benefit) => {
      benefit.target.forEach((target) => {
        if (isDefaultCategory(target)) {
          return;
        }

        removeCustomCategory(target);
      });
    });

    const updatedIdea = getUpdatedIdea(subtraction, currentTab, "subtraction", initialState);

    setSubtraction({ ...initialState, ...updatedIdea });

    if (currentTab === 0) {
      updateUploadInfo({ ...initialUpload });
    }

    updateUploadInfo({ ...initialUpload });
    setCurrentPage(0);
    setIsNew(!edit);
  };

  const deleteSubtractionsMatrix = () => {
    const currentSubtraction = getSubtraction();

    if (!subtractionId) {
      handleCloseDialog();
    }

    const issuesToDelete = currentSubtraction.issues.map((issue) => ({ id: issue.id })) || [];
    const params = {
      issues: issuesToDelete,
      ideaId: subtractionId || "",
    };

    const onSuccess = () => {
      handleCloseConfirmationDeleteModalOpen();
      handleCloseDialog();
    };

    const onError = (error) => {
      console.error(error);
    };

    params.ideaId && deleteIdea(params, onSuccess, onError);
  };

  const archivedSubtractionsMatrix = () => {
    if (!subtractionId) {
      handleCloseDialog();
    }

    const params = {
      ideas: { subtractionsIds: [subtractionId] },
      productId: productId,
    };

    const onSuccess = ({ trashFull }) => {
      if (trashFull) {
        handleOpenConfirmationDeleteModalOpen();
      } else {
        handleCloseDialog();
      }
    };

    const onError = (error) => {
      console.error(error);
    };

    params.ideas && archiveIdeas(params, onSuccess, onError);
  };

  const updateValues = () => {
    updateSubtractionDetails(false);
  };

  const updateSubtractionDetails = () => {
    const currentSubtraction = subtractionsMatrix;

    if (Object.keys(currentSubtraction).length) {
      const benefitsOfSubtraction = currentSubtraction.potentialBenefitsOfSubtraction;
      const hasBenefitsOfSubtraction = benefitsOfSubtraction && benefitsOfSubtraction.length > 0;
      const issues = currentSubtraction.issues;
      const hasIssues = issues && issues.length > 0;
      const issuesMessages = [
        ...messages,
        ...(currentSubtraction.issuesMessages ? currentSubtraction.issuesMessages : []),
      ];
      const hasIssuesMessages = issuesMessages && issuesMessages.length > 0;
      const image = currentSubtraction.image;
      const currentRating =
        currentSubtraction.rating === null ? null : currentSubtraction.rating === 0 ? 0 : currentSubtraction.rating;
      const currentFeasibleRating =
        currentSubtraction.feasibleRating === null
          ? null
          : currentSubtraction.feasibleRating === 0
            ? 0
            : currentSubtraction.feasibleRating;

      const params = {
        existingSubtraction: currentSubtraction.existingSubtraction,
        isIdeaNew: currentSubtraction.potentialBenefits,
        isIdeaFeasible: currentSubtraction.typeSubtraction,
        score: currentRating,
        feasibleScore: currentFeasibleRating,
        potentialBenefitsOfSubtraction: (hasBenefitsOfSubtraction && benefitsOfSubtraction) || [
          { name: "", description: "", target: [], userInfo: "" },
        ],
        issues: (hasIssues && issues) || [{ comment: "", description: "", createdByUser: "" }],
        issuesMessages: (hasIssuesMessages && issuesMessages) || [],
        ideaName: currentSubtraction.subtractionName || "",
        comment: currentSubtraction.comments || "",
        image: image || initialState.image,
        imagesLibrary: currentSubtraction.imagesLibrary,
        removeBenefit: currentSubtraction.removeBenefit,
      };

      if (image && image.name) {
        updateUploadInfo({
          ...initialUpload,
          name: image.originalName,
          date: image.date,
          size: image.size,
          uploadName: image.name,
          uploaded: true,
          id: image.id,
        });
      }
      const updatedDependency = { ...getSubtraction(), ...params };
      handleSetSubtraction(updatedDependency);
      setSavedSubtraction({ ...updatedDependency });
    } else {
      handleSetSubtraction({ ...initialState });
      setSavedSubtraction({ ...initialState });
    }
  };

  const getMessageForCheckRating = () => {
    return (
      <p className="flex-column mt-25px">
        <span style={{ margin: "0" }}>{getTranslation("RATING_REQUIRED_MODAL_NOT_RATE_IMPACT")}</span>
        <span>{getTranslation("RATING_REQUIRED_MODAL_NOT_RATE_FEASIBILITY")}</span>
      </p>
    );
  };

  const checkRating = () => {
    if (
      currentTab === 2 &&
      (subtraction.score === null || subtraction.score === undefined) &&
      (subtraction.feasibleScore === null || subtraction.feasibleScore === undefined)
    ) {
      setError({
        openErrorModal: true,
        message: getMessageForCheckRating(),
        headerError: getTranslation("RATING_REQUIRED_MODAL_HEADER"),
      });
      return;
    }

    if (
      currentTab === 2 &&
      subtraction.score &&
      (subtraction.feasibleScore === null || subtraction.feasibleScore === undefined)
    ) {
      setError({
        openErrorModal: true,
        message: `${getTranslation("RATING_REQUIRED_MODAL_NOT_RATE_FEASIBILITY")}`,
        headerError: getTranslation("RATING_REQUIRED_MODAL_HEADER"),
      });
      return;
    }

    if (
      currentTab === 2 &&
      subtraction.feasibleScore &&
      (subtraction.score === null || subtraction.score === undefined)
    ) {
      setError({
        openErrorModal: true,
        message: `${getTranslation("RATING_REQUIRED_MODAL_NOT_RATE_IMPACT")}`,
        headerError: getTranslation("RATING_REQUIRED_MODAL_HEADER"),
      });
      return;
    }

    isNew ? createSubtraction(true) : updateSubtractionsMatrix(true);
  };

  const updateSubtractionsMatrix = (shouldClose = false) => {
    if (!subtractionId) {
      return;
    }

    shouldClose && setIsClosing(true);

    const params = {
      id: subtractionId,
      idRemoteComponent: remoteComponent.id,
      productId: productId,
      customCategories: getCustomCategories(),
      teamId: teamId || "",
      ...getSubtractionDetails(false),
    };

    params.imagesLibrary = params.imagesLibrary.map((image) => {
      const imageCopy = { ...image };
      delete imageCopy.imageSource;
      return imageCopy;
    });

    delete params.image.imageSource;

    setIsPending({ ...isPending, update: true });
    const onSuccess = () => {
      handleClose(shouldClose, { ...isPending, update: false });
      setIsLoadingImage(false);
    };

    const onError = (error) => {
      console.error(error);
      handleClose(shouldClose, { ...isPending, update: false });
    };

    const issues = getIssuesWithMessages() || [];

    const issuesParams = {
      ideaId: subtractionId || "",
      issues,
    };

    const onSuccessUpdateIssues = () => {};

    const onErrorUpdateIssues = (error) => {
      console.error(error);
    };

    if (shouldClose && !isPending.update) {
      createIssuesWithMessages(issuesParams, onSuccessUpdateIssues, onErrorUpdateIssues);
    }

    updateIdea(params, onSuccess, onError);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    handleSetSubtraction({ ...getSubtraction(), [name]: value });
  };

  const handleAddIssue = () => {
    const currentDependency = getSubtraction();

    const lastIssue = currentDependency?.issues[currentDependency?.issues?.length - 1];

    if (lastIssue?.comment || currentDependency?.issues?.length === 0) {
      handleSetSubtraction({
        ...currentDependency,
        issues: [...currentDependency.issues, { comment: "", description: "", createdByUser: "" }],
      });
    }
  };

  const handleRemoveIssue = (index) => {
    const currentDependency = getSubtraction();
    const filteredIssues = currentDependency.issues.filter((issue, issueIndex) => issueIndex !== index);
    const filteredMessages = currentDependency.issuesMessages.map((message) => {
      if (message.issueIndex > index) {
        return { ...message, issueIndex: --message.issueIndex };
      } else if (message.issueIndex === index) {
        return {};
      }
      return message;
    });
    handleSetSubtraction({
      ...currentDependency,
      issues: [...filteredIssues],
      issuesMessages: [...filteredMessages],
      deletedIssues: [
        ...(currentDependency.deletedIssues ? currentDependency.deletedIssues : []),
        { id: currentDependency.issues[index].id },
      ],
    });
  };

  const removeLastIssue = (index, idIssues) => {
    const currentSubtraction = getSubtraction();
    const foundIssue = currentSubtraction.issues.find((issue, issueIndex) => issueIndex === index);

    let filteredMessages = [];

    if (idIssues) {
      filteredMessages = currentSubtraction.issuesMessages.filter((message) => idIssues !== message.issueId);
    } else {
      filteredMessages = currentSubtraction.issuesMessages.filter((message) => message.issueIndex !== index);
    }

    foundIssue.comment = "";
    foundIssue.description = "";
    foundIssue.createdByUser = "";

    handleSetSubtraction({
      ...currentSubtraction,
      issues: [...currentSubtraction.issues],
      issuesMessages: [...filteredMessages],
      deletedIssues: [
        ...(currentSubtraction.deletedIssues ? currentSubtraction.deletedIssues : []),
        { id: currentSubtraction.issues[index].id },
      ],
    });
  };

  const removeMessage = (indexMessage, idSavedMessage) => {
    const currentSubtraction = getSubtraction();
    let filteredMessages = [];

    if (idSavedMessage) {
      filteredMessages = currentSubtraction.issuesMessages.filter((message) => idSavedMessage !== message._id);
    } else {
      filteredMessages = currentSubtraction.issuesMessages.filter((message, index) => index !== indexMessage);
    }

    handleSetSubtraction({
      ...currentSubtraction,
      issuesMessages: [...filteredMessages],
    });
  };

  const removeLastMessage = (indexMessage, issueId, idSavedMessage) => {
    const currentSubtraction = getSubtraction();
    let foundMessage = {};

    if (idSavedMessage) {
      foundMessage = currentSubtraction.issuesMessages.find((message) => idSavedMessage === message._id);
    } else {
      foundMessage = currentSubtraction.issuesMessages.find(
        (message, index) => indexMessage === index && issueId === message.issueIndex,
      );
    }

    foundMessage.message = "";

    handleSetSubtraction({
      ...currentSubtraction,
      issuesMessages: [...currentSubtraction.issuesMessages],
    });
  };

  const handleIssueChange = (index, value, name) => {
    const currentDependency = { ...getSubtraction() };
    const changedIssues = [...currentDependency.issues];
    if (name === "comment") {
      changedIssues[index].comment = value;
      changedIssues[index].createdByUser = `${props.userFullName.name} ${props.userFullName.lastName}`;
    }

    if (name === "description") {
      changedIssues[index].description = value;
    }

    handleSetSubtraction({ ...currentDependency, issues: [...changedIssues] });
  };

  const handleAddIssueMessage = (issueId, issueIndex) => {
    const currentDependency = getSubtraction();
    const filteredMessages =
      currentDependency?.issuesMessages.filter((message) =>
        message.issueId ? message.issueId === issueId : message.issueIndex === issueIndex,
      ) || [];

    const lastMessage = filteredMessages[filteredMessages.length - 1];
    const canBeCreated = !lastMessage || lastMessage.message !== "";

    if (canBeCreated) {
      handleSetSubtraction({
        ...currentDependency,
        issuesMessages: [...currentDependency.issuesMessages, { message: "", issueId, issueIndex }],
      });
    }
  };

  const handleIssueMessageChange = (value, index, userId, issueIndex) => {
    const currentSubtraction = getSubtraction();
    const changedIssuesMessages = [...currentSubtraction.issuesMessages];
    changedIssuesMessages[index] = { message: value, userId, issueIndex };
    handleSetSubtraction({ ...currentSubtraction, issuesMessages: changedIssuesMessages });
  };

  const updateBenefit = (name, index, subtraction, value) => {
    const changedBenefits = [...subtraction.potentialBenefitsOfSubtraction];
    const newBenefit = {
      ...changedBenefits[index],
      userInfo: `${props.userFullName.name} ${props.userFullName.lastName}`,
    };
    newBenefit[name] = value;
    changedBenefits[index] = newBenefit;
    handleSetSubtraction({ ...subtraction, potentialBenefitsOfSubtraction: changedBenefits });
  };

  const handleTargetChange = (index, { id, name }) => {
    const currentSubtraction = getSubtraction();

    const updatedTarget = [...currentSubtraction.potentialBenefitsOfSubtraction[index].target];
    const indexUpdatedTarget = updatedTarget.findIndex((target) => target.name === name);

    if (indexUpdatedTarget === -1) {
      updatedTarget.push({ id, name });
    } else {
      updatedTarget.splice(indexUpdatedTarget, 1);
    }

    updateBenefit("target", index, currentSubtraction, updatedTarget);
  };

  const handleBenefitChange = (index, value, name) => {
    const currentSubtraction = getSubtraction();
    updateBenefit(name, index, currentSubtraction, value);
  };

  const handleDeleteOption = (changedLabel) => {
    const currentSubtraction = getSubtraction();

    currentSubtraction.potentialBenefitsOfSubtraction.forEach((benefit) => {
      benefit.target = benefit.target.filter((targetElement) => targetElement.name !== changedLabel);
    });

    handleSetSubtraction({
      ...currentSubtraction,
      potentialBenefitsOfSubtraction: currentSubtraction.potentialBenefitsOfSubtraction,
    });

    removeCustomCategory(changedLabel);
  };

  const addBenefit = () => {
    const currentSubtraction = getSubtraction();
    handleSetSubtraction({
      ...currentSubtraction,
      potentialBenefitsOfSubtraction: [
        ...currentSubtraction.potentialBenefitsOfSubtraction,
        { name: "", description: "", target: [], userInfo: "" },
      ],
    });
  };

  const removeBenefit = (index) => {
    const currentSubtraction = getSubtraction();
    removeCustomCategory(currentSubtraction.potentialBenefitsOfSubtraction[index].target);
    const filteredBenefits = currentSubtraction.potentialBenefitsOfSubtraction.filter(
      (benefit, benefitIndex) => benefitIndex !== index,
    );
    handleSetSubtraction({ ...currentSubtraction, potentialBenefitsOfSubtraction: [...filteredBenefits] });
  };

  const subtractionComponents = {
    firstComponent: projectName || "",
    secondComponent: remoteComponent.name || "",
  };

  const removeLastBenefit = (index) => {
    const currentSubtraction = getSubtraction();
    removeCustomCategory(currentSubtraction.potentialBenefitsOfSubtraction[index].target);
    const foundBenefit = currentSubtraction.potentialBenefitsOfSubtraction.find(
      (benefit, benefitIndex) => benefitIndex === index,
    );

    foundBenefit.name = "";
    foundBenefit.description = "";
    foundBenefit.target = [];
    foundBenefit.userInfo = "";

    handleSetSubtraction({
      ...currentSubtraction,
      potentialBenefitsOfSubtraction: [...currentSubtraction.potentialBenefitsOfSubtraction],
    });
  };

  const handleSetCurrentTab = (value) => {
    const currentSubtraction = getSubtraction();
    if (!currentSubtraction.existingSubtraction || currentSubtraction.isIdeaNew) {
      if (value === 0 || value === 1) {
        setCurrentPage(value);
      } else {
        setCurrentPage(value + 1);
      }

      setCurrentTab(value);
      handleSave();
    }
  };

  const handleRightClick = () => {
    if (currentTab === 1 && (subtraction.score === null || subtraction.score === undefined)) {
      setError({
        openErrorModal: true,
        message: `${getTranslation("RATING_REQUIRED_MODAL_NOT_RATE_IMPACT")}`,
        headerError: getTranslation("RATING_REQUIRED_MODAL_HEADER"),
      });
      return;
    }

    handleSetCurrentTab(currentTab + 1);
    setCurrentPage(currentPage + 1);
  };

  const handleLeftClick = () => {
    handleSetCurrentTab(currentTab - 1);
    setCurrentPage(currentPage - 1);
  };

  const handleSave = () => {
    const upToDate = compareSubtractions(savedSubtraction, subtraction);

    if (!upToDate) {
      const updatedSubtraction = { ...getSubtraction() };

      setSavedSubtraction(updatedSubtraction);
      isNew ? createSubtraction() : updateSubtractionsMatrix();
    }
  };

  const compareSubtractions = (firstItem, secondItem) => {
    const keys = Object.keys(firstItem);
    let isEqual = true;

    for (let key of keys) {
      if (key === "potentialBenefitsOfSubtraction") {
        const firstBenefit =
          firstItem[key] &&
          firstItem[key].filter((benefit) => benefit.name && benefit.target && benefit.description && benefit.userInfo);
        const secondBenefit =
          secondItem[key] &&
          secondItem[key].filter(
            (benefit) => benefit.name && benefit.target && benefit.description && benefit.userInfo,
          );

        if (firstBenefit.length !== secondBenefit.length) {
          isEqual = false;
          break;
        }

        for (let benefit of firstBenefit) {
          const foundBenefit = secondBenefit.find(
            (item) =>
              item.name === benefit.name &&
              item.target === benefit.target &&
              item.description === benefit.description &&
              item.userInfo === benefit.userInfo,
          );
          if (!foundBenefit) {
            isEqual = false;
            break;
          }
        }

        continue;
      }

      if (key === "issues") {
        if (firstItem[key].join("") !== secondItem[key].join("")) {
          isEqual = false;
          break;
        }
        continue;
      }

      if (key === "issuesMessages") {
        if (firstItem[key].join("") !== secondItem[key].join("")) {
          isEqual = false;
          break;
        }
        continue;
      }

      if (key === "image") {
        if (firstItem[key].name !== secondItem[key].name) {
          isEqual = false;
          break;
        }
        continue;
      }

      if (firstItem[key] !== secondItem[key]) {
        isEqual = false;
        break;
      }
    }

    return isEqual;
  };

  const prevEnabled = () => {
    if (currentTab === 0) {
      return false;
    }

    return true;
  };

  const nextEnabled = () => {
    if (currentTab === 2) {
      return false;
    }

    return true;
  };

  const isCompleted = () => {
    const currentSubtraction = getSubtraction();
    return (
      currentSubtraction.existingSubtraction === true ||
      currentSubtraction.isIdeaNew === false ||
      currentSubtraction.isIdeaFeasible === false ||
      (currentSubtraction.isIdeaFeasible === true && currentSubtraction.score > 0)
    );
  };

  const handleSetSubtraction = (value) => {
    setSubtraction(value);
  };

  const handleImageUpload = (file, imageSource = null) => {
    const CancelToken = axios.CancelToken;

    const formData = new FormData();
    formData.append("image", file, file.name);
    updateUploadInfo({ progress: 0, cancel: null, uploaded: false, name: file.name, size: file.size });

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const completed = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        updateUploadInfo({ progress: completed });
      },
      cancelToken: new CancelToken(function executor(c) {
        updateUploadInfo({ cancel: c });
      }),
    };

    const onSuccess = (response) => {
      updateUploadInfo({ uploaded: true, date: new Date(), uploadName: response.filename, id: response.imageId });
      const image = {
        name: response.filename,
        originalName: file.name,
        id: response.imageId,
        imageSource,
      };

      const currentSubtraction = getSubtraction();

      if (!currentSubtraction.imagesLibrary.length) {
        handleSetSubtraction({
          ...currentSubtraction,
          imagesLibrary: [...currentSubtraction.imagesLibrary, image],
          image,
        });
        return;
      }
      handleSetSubtraction({ ...currentSubtraction, imagesLibrary: [...currentSubtraction.imagesLibrary, image] });
    };

    const onError = (error) => {
      console.error(error);
      if (uploadInfo.name) {
        updateUploadInfo({ ...initialUpload });
      }
    };

    setIsLoadingImage(true);
    uploadImage(formData, config, onSuccess, onError);
  };

  const handleCancelClick = () => {
    setNewGeneratedImage({
      isNew: false,
      urlImage: "",
    });
    uploadInfo.cancel && uploadInfo.cancel("Canceled by user");
    updateUploadInfo({ ...initialUpload });

    const currentSubtraction = getSubtraction();
    handleSetSubtraction({ ...currentSubtraction, image: initialState.image });
  };

  const updateUploadInfo = (value) => {
    if (value) {
      setUploadInfo((state) => ({ ...state, ...value }));
    } else {
      setUploadInfo((state) => ({ ...state, ...initialUpload }));
    }
  };

  const currentUploadInfo = uploadInfo;

  const handleCloseDialog = () => {
    setIsClosing(true);
    const upload = uploadInfo;
    if (upload.name && !upload.uploaded) {
      upload.cancel && upload.cancel("Canceled by user");
    }

    setUploadInfo({ ...initialUpload });
    closeDialog && closeDialog();
  };

  const matrixBodyClass = [1, 2].includes(currentTab) ? " benefits-container" : "";

  const addCustomCategory = (name) => {
    const foundCategory = customCategories.find((category) => category.name === name);
    if (foundCategory) {
      foundCategory.count++;
      return;
    }

    const currentId = customCategories[customCategories.length - 1]?.id;

    setCustomCategories([
      ...customCategories,
      {
        id: _.isNumber(currentId) ? currentId + 1 : 3,
        name,
        count: 1,
      },
    ]);
  };

  const removeCustomCategory = (name) => {
    const updatedCategories = customCategories.filter((category) => category.name !== name);
    setCustomCategories(updatedCategories);
  };

  const renameCustomCategory = (oldName, newName) => {
    const foundCategoryIndex = customCategories.findIndex((category) => category.name === newName);
    if (foundCategoryIndex !== -1) {
      customCategories[foundCategoryIndex].count++;

      return;
    }

    const subscraction = getSubtraction();

    subscraction.potentialBenefitsOfSubtraction.forEach((benefit) => {
      const currentTargetIndex = benefit.target.findIndex((target) => target.name === oldName);

      if (currentTargetIndex !== -1) {
        benefit.target.splice(currentTargetIndex, 1, { id: benefit.target[currentTargetIndex].id, name: newName });
      }
    });

    handleSetSubtraction({
      ...subscraction,
      potentialBenefitsOfSubtraction: subscraction.potentialBenefitsOfSubtraction,
    });

    const copiedArray = [...customCategories];
    const findOldCategoryIndex = customCategories.findIndex((category) => category.name === oldName);

    const { count, id } = customCategories[findOldCategoryIndex];

    copiedArray.splice(findOldCategoryIndex, 1, { id, count, name: newName });
    setCustomCategories(copiedArray);
  };

  const getCustomCategories = () => {
    return customCategories.filter((category) => category.count >= 0);
  };

  const addIdeasName = (ideasName) => {
    setSubtraction({ ...subtraction, ideaName: ideasName });
    setOpenGenerateModal(false);
    setSuggestedOptions([]);
  };

  const addGenerateBenefits = () => {
    const benefits = [];

    suggestedOptions.map((benefit) => {
      if (selectedGenerateOptions.has(`${benefit}`)) {
        const params = {
          name: benefit.includes("：") ? benefit.split("：")[0] : benefit.split(":")[0],
          description: benefit.includes("：") ? benefit.split("：")[1] : benefit.split(":")[1],
          target: [],
          userInfo: "AI",
        };
        benefits.push(params);
      }
    });

    setSubtraction({
      ...subtraction,
      potentialBenefitsOfSubtraction: [...benefits, ...subtraction.potentialBenefitsOfSubtraction],
    });

    setOpenGenerateModal(false);
    setSelectedGenerateOptions(new Set());
    setSuggestedOptions([]);
  };

  const selectGenerateOption = (nameOption) => {
    setSelectedGenerateOptions((prev) => {
      const prevSelectedOption = new Set(prev);
      const key = `${nameOption}`;
      prev.has(key) ? prevSelectedOption.delete(key) : prevSelectedOption.add(key);
      return prevSelectedOption;
    });
  };

  const generateNames = () => {
    setOpenGenerateModal(true);

    const onSuccess = ({ parsedChoices, numberRequests }) => {
      setSuggestedOptions(parsedChoices);
      setSuggestedLoading(false);
    };

    const onError = (error) => {
      setIsOpenGenerateImageModal(false);
      const { message, code } = error.response && error.response.data;

      if (code === "30840" || code === "30841") {
        setOpenGenerateModal(false);
        setIsOpenWarningModal(true);
        setSuggestedLoading(false);
        setIsEnoghTokensForImage(code !== "30841");
        return;
      }

      setError({
        openErrorModal: true,
        message: getTranslation(message) || error,
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
      setSuggestedLoading(false);
    };

    setSuggestedLoading(true);

    const currentSubtraction = getSubtraction();
    const description = currentSubtraction.comment ? currentSubtraction.comment : descriptionOfIdea;

    getGeneratedNamesForIdea(
      {
        projectName: productName ? productName : projectName,
        projectId: productId,
        descriptionOfIdea: description,
        language,
      },
      onSuccess,
      onError,
    );
  };

  const closeGenerateModal = () => {
    setOpenGenerateModal(false);
    setSuggestedOptions([]);
  };

  const handleChangeScore = (e) => {
    setSubtraction({ ...subtraction, score: e });
  };

  const handleChangeFeasibleScore = (e) => {
    setSubtraction({ ...subtraction, isIdeaFeasible: e > 0, feasibleScore: e });
  };

  const closeErrorWindow = () => {
    setError({
      openErrorModal: false,
      message: "",
      headerError: "",
    });
  };

  const generateBenefits = () => {
    setOpenGenerateModal(true);

    const onSuccess = ({ parsedChoices, numberRequests }) => {
      setSuggestedOptions(parsedChoices);
      setSuggestedLoading(false);
    };

    const onError = (error) => {
      setIsOpenGenerateImageModal(false);
      const { message, code } = error.response && error.response.data;

      if (code === "30840" || code === "30841") {
        setOpenGenerateModal(false);
        setIsOpenWarningModal(true);
        setSuggestedLoading(false);
        setIsEnoghTokensForImage(code !== "30841");
        return;
      }

      setError({
        openErrorModal: true,
        message: getTranslation(message) || error,
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
      setSuggestedLoading(false);
    };

    setSuggestedLoading(true);

    const currentSubtraction = getSubtraction();
    const description = currentSubtraction.comment ? currentSubtraction.comment : descriptionOfIdea;

    getGeneratedBenefits(
      {
        projectName: productName ? productName : projectName,
        projectId: productId,
        descriptionOfIdea: description,
        language,
      },
      onSuccess,
      onError,
    );
  };

  const generateChallenges = () => {
    setOpenGenerateModal(true);

    const onSuccess = ({ parsedChoices, numberRequests }) => {
      setSuggestedOptions(parsedChoices);
      setSuggestedLoading(false);
    };

    const onError = (error) => {
      setIsOpenGenerateImageModal(false);
      const { message, code } = error.response && error.response.data;

      if (code === "30840" || code === "30841") {
        setOpenGenerateModal(false);
        setIsOpenWarningModal(true);
        setSuggestedLoading(false);
        setIsEnoghTokensForImage(code !== "30841");
        return;
      }

      setError({
        openErrorModal: true,
        message: getTranslation(message) || error,
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
      setSuggestedLoading(false);
    };

    setSuggestedLoading(true);

    const currentDependency = getSubtraction();
    const description = currentDependency.comment ? currentDependency.comment : descriptionOfIdea;

    getGeneratedChallenges(
      {
        projectName: productName ? productName : projectName,
        projectId: productId,
        descriptionOfIdea: description,
        language,
      },
      onSuccess,
      onError,
    );
  };

  const addGenerateChallenges = () => {
    const generatedIssues = [];

    suggestedOptions.map((issue) => {
      if (selectedGenerateOptions.has(`${issue}`)) {
        const params = {
          comment: issue.includes("：") ? issue.split("：")[0] : issue.split(":")[0],
          description: issue.includes("：") ? issue.split("：")[1] : issue.split(":")[1],
          createdByUser: "AI",
        };
        generatedIssues.push(params);
      }
    });

    setSubtraction({
      ...subtraction,
      issues: [...generatedIssues, ...subtraction.issues],
    });

    setOpenGenerateModal(false);
    setSelectedGenerateOptions(new Set());
    setSuggestedOptions([]);
  };

  const changeCurrentTab = (index) => {
    setCurrentTab(index);
  };

  const header = {
    projectName: project.product.name,
    productName,
    component: subtractionComponents.secondComponent,
  };

  const getSubtractionHeader = () => {
    return (
      <p className="subtraction-modal-header-imagine">
        {getTranslation("SUBTRACTION_DESCRIPTION_IMAGINE_A")}
        <u>{header.productName ? header.productName : header.projectName}</u>
        {getTranslation("SUBTRACTION_DESCRIPTION_WITHOUT_THE")}
        <u>{header.component}</u>
        {productType === "process" && <span>{getTranslation("SUBTRACTION_MODAL_HEADER_STEP")}</span>}
      </p>
    );
  };

  const convertImage = async (imageBase64) => {
    try {
      const base64Response = await fetch(`data:image/png;base64,${imageBase64}`);
      const blobImage = await base64Response.blob();

      let dt = new DataTransfer();
      dt.items.add(new File([blobImage], "image.png", { type: blobImage.type }));
      const fileImage = dt.files[0];
      const bufferImage = await fileImage.arrayBuffer();

      const reader = new FileReader();

      reader.onload = () => {
        const imageUrl = `data:image/png;base64,${Buffer.from(bufferImage).toString("base64")}`;
        setPotentialGeneratedImageUrl(imageUrl);
      };

      reader.readAsArrayBuffer(fileImage);

      return fileImage;
    } catch (error) {
      setError({
        openErrorModal: true,
        message: error,
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
    }
  };

  const handleAcceptPotentialImage = () => {
    setGeneratedImage(potentialGeneratedImageUrl);
    handleImageUpload(potentialGeneratedImageFile, potentialGeneratedImageUrl);
    setIsOpenGenerateImageModal(false);
  };

  const selectCurrentSubtractionImageFromLibrary = (index) => {
    const currentSubtraction = getSubtraction();
    handleSetSubtraction({ ...currentSubtraction, image: currentSubtraction.imagesLibrary[index] });
  };

  const removeImageFromLibrary = (id) => {
    const currentSubtraction = getSubtraction();
    const imagesLibrary = [...currentSubtraction.imagesLibrary];
    const indexOfSelectedImage = imagesLibrary.findIndex((image) => image.id === id);

    if (id === currentSubtraction.image.id) {
      const newCurrentImageIndex = indexOfSelectedImage
        ? imagesLibrary.length % indexOfSelectedImage
        : imagesLibrary.length - 1;

      handleSetSubtraction({
        ...currentSubtraction,
        image: imagesLibrary.length - 1 ? imagesLibrary[newCurrentImageIndex] : initialState.image,
        imagesLibrary: imagesLibrary.filter((image) => image.id !== id),
      });
      return newCurrentImageIndex;
    }
    handleSetSubtraction({ ...currentSubtraction, imagesLibrary: imagesLibrary.filter((image) => image.id !== id) });
    return imagesLibrary.findIndex((image) => image.id === currentSubtraction.image.id);
  };

  const generateImage = () => {
    setIsOpenGenerateImageModal(true);

    const onSuccess = async (imageBase64) => {
      setNewGeneratedImage({
        isNew: true,
        urlImage: `data:image/png;base64,${imageBase64}`,
      });
      const fileImage = await convertImage(imageBase64);

      setPotentialGeneratedImageFile(fileImage);
      setSuggestedLoading(false);
    };

    const onError = (error) => {
      setIsOpenGenerateImageModal(false);
      const { message, code } = error.response && error.response.data;

      if (code === "30840" || code === "30841") {
        setOpenGenerateModal(false);
        setIsOpenWarningModal(true);
        setSuggestedLoading(false);
        setIsEnoghTokensForImage(code !== "30841");
        return;
      }

      setError({
        openErrorModal: true,
        message: getTranslation(message) || error,
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
      setSuggestedLoading(false);
    };

    setSuggestedLoading(true);

    const currentSubtraction = getSubtraction();
    const description = currentSubtraction.comment ? currentSubtraction.comment : descriptionOfIdea;

    getGeneratedImage(
      {
        descriptionOfIdea: description,
        language,
      },
      onSuccess,
      onError,
    );
  };

  const descriptionOfIdea = `
        ${productName ? productName : project.product.name}
        ${getTranslation("SUBTRACTION_DESCRIPTION_WITHOUT_THE")}
        ${subtractionComponents.secondComponent}
        ${productType === "process" ? getTranslation("SUBTRACTION_MODAL_HEADER_STEP") : ""}
    `.replace(/[\s]+/gi, " ");

  return (
    <Dialog closeDialog={handleCloseDialog} closeOnClickOutside={false}>
      <div className="subtraction-modal-wrapper">
        <SubtractionModalHeader
          closeDialog={handleCloseDialog}
          subtraction={getSubtraction()}
          currentTab={currentTab}
          setCurrentTab={handleSetCurrentTab}
          isCompletedIdea={isCompletedIdea}
          productType={productType}
          getSubtractionHeader={getSubtractionHeader}
          changeCurrentTab={changeCurrentTab}
        />

        <div className={"subtraction-modal-body flex-column" + matrixBodyClass}>
          <SubtractionModalTabs
            selectCurrentSubtractionImageFromLibrary={selectCurrentSubtractionImageFromLibrary}
            removeImageFromLibrary={removeImageFromLibrary}
            handleAcceptPotentialImage={handleAcceptPotentialImage}
            potentialGeneratedImageUrl={potentialGeneratedImageUrl}
            currentTab={currentTab}
            subtraction={getSubtraction()}
            setSubtraction={handleSetSubtraction}
            handleChange={handleChange}
            userFullName={props.userFullName}
            userId={props.userId}
            addBenefit={addBenefit}
            removeBenefit={removeBenefit}
            removeLastBenefit={removeLastBenefit}
            handleBenefitChange={handleBenefitChange}
            handleTargetChange={handleTargetChange}
            addIssue={handleAddIssue}
            removeIssue={handleRemoveIssue}
            removeLastIssue={removeLastIssue}
            removeMessage={removeMessage}
            removeLastMessage={removeLastMessage}
            handleIssueChange={handleIssueChange}
            uploadInfo={currentUploadInfo}
            newGeneratedImage={newGeneratedImage}
            handleCancelClick={handleCancelClick}
            handleFileSelect={handleImageUpload}
            customCategories={getCustomCategories()}
            isLoadingImage={isLoadingImage}
            currentPage={currentPage}
            addIssueMessage={handleAddIssueMessage}
            handleIssueMessageChange={handleIssueMessageChange}
            productType={productType}
            header={header}
            handleGenerateNames={generateNames}
            openGenerateModal={openGenerateModal}
            closeGenerateModal={closeGenerateModal}
            suggestedOptions={suggestedOptions}
            suggestedLoading={suggestedLoading}
            addIdeasName={addIdeasName}
            handleChangeScore={handleChangeScore}
            handleChangeFeasibleScore={handleChangeFeasibleScore}
            selectGenerateOption={selectGenerateOption}
            selectedGenerateOptions={selectedGenerateOptions}
            handleGenerateButton={generateBenefits}
            addGenerateBenefits={addGenerateBenefits}
            handleGenerateChallenges={generateChallenges}
            addGenerateChallenges={addGenerateChallenges}
            handleGenerateImage={generateImage}
            isOpenGenerateImageModal={isOpenGenerateImageModal}
            closeDialogGenerateImage={() => setIsOpenGenerateImageModal(false)}
            generatedImage={generatedImage}
            handleDeleteOption={handleDeleteOption}
            handleRenameOption={renameCustomCategory}
            addCustomCategory={addCustomCategory}
          />

          <IdeaNavigationFooter
            resetIdea={resetSubtractionsMatrix}
            prevEnabled={prevEnabled}
            nextEnabled={nextEnabled}
            handleRightClick={handleRightClick}
            handleLeftClick={handleLeftClick}
            disabledNextButton={disabledNextButton}
            undoResetIdea={undoResetIdea}
            checkedTab={checkedTab}
          />
        </div>

        <IdeaModalFooter
          deleteIdea={handleOpenConfirmationModalOpen}
          isCompleted={isCompleted}
          checkRating={checkRating}
          currentTab={currentTab}
          isDisabledSave={isDisabledSave}
        />

        {isConfirmationModalOpen && (
          <ConfirmationModal
            className="delete-conformation-modal"
            textContainerClass="span-delete-modal"
            closeDialog={handleCloseConfirmationModalOpen}
            message={getTranslation("CONFIRM_MODAL_DELETE_IDEA")}
            autoFocus={true}
            buttonText={getTranslation("EDIT_ATTRIBUTE_DIALOG_BUTTON_DELETE")}
            onConfirm={archivedSubtractionsMatrix}
          />
        )}

        {isConfirmationDeleteModalOpen && (
          <TrashModal
            closeDialog={handleCloseConfirmationDeleteModalOpen}
            onProceed={deleteSubtractionsMatrix}
            history={history}
            itemType="ideas"
            itemsCount={0}
          />
        )}

        {error.openErrorModal && (
          <ErrorMessageModal
            message={error.message}
            closeModalWindow={closeErrorWindow}
            textButton={getTranslation("CONFIRMATION_MODAL_DEFAULT_BUTTON_TEXT")}
            handleButton={closeErrorWindow}
            header={error.headerError}
          />
        )}

        {paymentInfo.key && (
          <CheckoutModal
            isOpenAISubscription
            closeDialog={() => setPaymentInfo((prev) => ({ ...prev, key: "" }))}
            subscriptionInfo={paymentInfo}
            history={history}
            mode="payment"
            setGeneratedOpenAIRequests={setGeneratedOpenAIRequests}
          />
        )}

        {isOpenBuyCreditsgModal && (
          <BuyMoreAICreditsModal setPaymentInfo={setPaymentInfo} closeDialog={() => setIsOpenBuyCreditsgModal(false)} />
        )}

        {isOpenWarningModal && (
          <WarningNotTokensModal
            closeDialog={() => {
              setIsOpenWarningModal(false);
            }}
            openBuyModal={() => setIsOpenBuyCreditsgModal(true)}
            history={history}
            isEnoghTokensForImage={isEnoghTokensForImage}
          />
        )}
      </div>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  language: state.auth.userInfo.language,
});

const mapDispatchToProps = {
  setGeneratedOpenAIRequests,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubtractionEditModal);
